<template>
  <ModalConfirmation
    hasBlur
    :primaryButtonProps="modalConfig.primaryButtonProps"
    :showModal="showModal"
    :title="modalConfig.title"
    @cancel="handleCancel"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <ParagraphBody
        v-for="text in modalText"
        :key="text"
      >
        {{ text }}
      </ParagraphBody>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  ModalConfirmation,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import { SecurityModalTitles, SecurityModalTypes } from 'client/settings/Security/SecuritySettingsConstants';

const { PrimaryButtonProps } = Types;

const modalTitlesMap = {
  [SecurityModalTypes.passwordAging]: SecurityModalTitles.passwordAging,
  [SecurityModalTypes.passwordLockout]: SecurityModalTitles.passwordLockout,
};

export default {
  name: 'ModalConfirmChange',

  components: {
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    itemChanged: {
      type: String,
      required: true,
    },
    modalText: {
      type: Array,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
    },
    showModal: Boolean,
  },

  computed: {
    modalConfig() {
      const primaryButtonProps = PrimaryButtonProps({
        text: 'continue',
      });

      const modalTitle = modalTitlesMap[this.modalType] || SecurityModalTitles.passwordAging;

      const modalConfig = {
        title: modalTitle,
        primaryButtonProps,
      };

      return modalConfig;
    },
  },

  methods: {

    handleCancel() {
      this.$emit('cancel', this.itemChanged);
    },

    handleClose() {
      this.$emit('close');
    },

    handleSave() {
      this.$emit('save', this.itemChanged);
    },
  },
};
</script>
